import { Component, Inject, OnInit } from "@angular/core";
import { MatDialogRef, MAT_DIALOG_DATA } from "@angular/material/dialog";
import { SnackBarService } from "../../../shared/service/snack.bar.service";
import {
  GetLangListGQL,
  ProjectSpecDetailForPurchaserAppSettingGQL,
  EditProjectSettingPurchaserAppGQL,
} from "../../../../generated/graphql";
import { FormControl, FormGroup } from "@angular/forms";
import { combineLatest } from "rxjs";
import { GraphQLError } from "graphql";

export interface DialogData {
  projectId: string;
}

@Component({
  selector: "project-setting-dialog",
  templateUrl: "project-setting-dialog.html",
})
export class ProjectSettingDialog implements OnInit {
  purchaserSetting: any[] = [];
  data: any;
  result: any;
  salesDetail: any;
  softwareCode: any;
  frmGrp: FormGroup;

  constructor(
    public dialogRef: MatDialogRef<ProjectSettingDialog>,
    @Inject(MAT_DIALOG_DATA) public dialogData: DialogData,
    private snackBarSvc: SnackBarService,
    private getLangListGQL: GetLangListGQL,
    private projectSpecDetailForPurchaserAppSettingGQL: ProjectSpecDetailForPurchaserAppSettingGQL,
    private editProjectSettingPurchaserAppGQL: EditProjectSettingPurchaserAppGQL,
    private snackSvc: SnackBarService,
  ) {}

  ngOnInit() {
    this.getData();
    this.formInit();
    this.getLangList();
  }

  private getData() {
    this.projectSpecDetailForPurchaserAppSettingGQL
      .fetch({
        projectId: this?.dialogData?.projectId,
      })
      .subscribe((result) => {
        if (result.errors) {
          this.snackBarSvc.show(result.errors[0].message);
          return;
        }
        this.data = result.data.GetProjectSpecByProjectId;
        this.setFrmData();
      });
  }

  getLangList() {
    this.getLangListGQL.fetch().subscribe((result) => {
      if (result.errors) {
        this.snackBarSvc.showQueryError(result.errors);
      }
      this.purchaserSetting = result.data.GetAllMasterInfo.PurchaserAppSetting;
    });
  }

  private formInit() {
    this.frmGrp = new FormGroup({
      project_id: new FormControl(),
      purchaser_app_setting: new FormControl(""),
      bookingInfo: new FormControl(true),
      overallSiteProgressBooked: new FormControl(true),
      loan: new FormControl(true),
      s_and_p: new FormControl(true),
      overallSiteProgressSigned: new FormControl(true),
      accounts: new FormControl(true),
      keyCollection: new FormControl(true),
      booked: new FormControl(true),
      signed: new FormControl(true),
    });

    combineLatest([
      this.frmGrp.get("bookingInfo").valueChanges,
      this.frmGrp.get("overallSiteProgressBooked").valueChanges,
      this.frmGrp.get("loan").valueChanges,
    ]).subscribe(() =>
      this.updateMainNotificationField(
        ["bookingInfo", "overallSiteProgressBooked", "loan"],
        "booked",
      ),
    );

    combineLatest([
      this.frmGrp.get("s_and_p").valueChanges,
      this.frmGrp.get("overallSiteProgressSigned").valueChanges,
      this.frmGrp.get("accounts").valueChanges,
      this.frmGrp.get("keyCollection").valueChanges,
    ]).subscribe(() =>
      this.updateMainNotificationField(
        ["s_and_p", "overallSiteProgressSigned", "accounts", "keyCollection"],
        "signed",
      ),
    );
  }
  private setFrmData() {
    this.frmGrp.controls.project_id.setValue(this?.dialogData?.projectId);
    if (this.data.purchaserAppSetting) {
      this.frmGrp.controls.purchaser_app_setting.setValue(
        this.data.purchaserAppSetting,
      );
    }

    if (this.data.purchaserAppSubmenu) {
      this.frmGrp.controls.bookingInfo.setValue(
        this.data.purchaserAppSubmenu?.booked.booking_info,
      );
      this.frmGrp.controls.overallSiteProgressBooked.setValue(
        this.data.purchaserAppSubmenu?.booked.overall_site_progress,
      );
      this.frmGrp.controls.loan.setValue(
        this.data.purchaserAppSubmenu?.booked.loan,
      );
      this.frmGrp.controls.s_and_p.setValue(
        this.data.purchaserAppSubmenu?.signed.s_and_p,
      );
      this.frmGrp.controls.overallSiteProgressSigned.setValue(
        this.data.purchaserAppSubmenu?.signed.overall_site_progress,
      );
      this.frmGrp.controls.accounts.setValue(
        this.data.purchaserAppSubmenu?.signed.accounts,
      );
      this.frmGrp.controls.keyCollection.setValue(
        this.data.purchaserAppSubmenu?.signed.key_collection,
      );
    }
  }

  updateMainNotificationField(
    fields: string[],
    notificationControlName: string,
  ) {
    const values = fields.map((field) => this.frmGrp.get(field)?.value);
    const shouldSetNotification = values.some((value) => !!value);
    this.frmGrp.get(notificationControlName)?.setValue(shouldSetNotification);
  }

  updateNotificationFields(fields: string[], event: any) {
    const isChecked = event.checked;
    if (isChecked) {
      fields.forEach((x) => {
        this.frmGrp.get(x)?.setValue(true);
      });
    } else {
      fields.forEach((x) => {
        this.frmGrp.get(x)?.setValue(false);
      });
    }
  }

  save() {
    this.frmGrp.markAllAsTouched();
    let formVal = this.frmGrp.controls;
    if (this.frmGrp.valid) {
      this.editProjectSettingPurchaserAppGQL
        .mutate(
          {
            input: {
              projectId: this.dialogData.projectId,
              purchaser_app_setting: formVal.purchaser_app_setting.value,
              purchaserAppSubmenu: {
                booked: {
                  booking_info: formVal.bookingInfo.value,
                  overall_site_progress:
                    formVal.overallSiteProgressBooked.value,
                  loan: formVal.loan.value,
                },
                signed: {
                  s_and_p: formVal.s_and_p.value,
                  overall_site_progress:
                    formVal.overallSiteProgressSigned.value,
                  accounts: formVal.accounts.value,
                  key_collection: formVal.keyCollection.value,
                },
              },
            },
          },
          {
            context: {
              useMultipart: true,
            },
          },
        )
        .subscribe(
          () => {
            this.dialogRef.close(true);
            this.snackSvc.show("Setting had update   Successfully");
          },
          (err: GraphQLError) => {
            this.snackSvc.showMutationError(err);
          },
        );
    }
  }
}
